import { Button, Circle, styled, View, XStack, type XStackProps } from "tamagui";
import { hairline } from "../utils";
import { pressVariants } from "./Motion/motion";
export const StyledCircle = styled(Circle, {
  size: "$5",
  backgroundColor: "$surface0",
  zIndex: 2,
  justifyContent: "center",
  alignItems: "center",
  mb: "$3.5",
  variants: {
    whiteShadow: {
      true: {
        backgroundColor: "$surface2",
        shadowColor: "black",
        shadowOffset: {
          height: 4,
          width: 0
        },
        shadowRadius: 4,
        shadowOpacity: 0.08
      },
      false: {}
    }
  } as const
});
export const SquareIconWrapper = styled(XStack, {
  height: "$3",
  width: "$3",
  alignItems: "center",
  justifyContent: "center",
  borderRadius: "$3",
  backgroundColor: "$surface0"
});
export const RefreshButtonClickProps: XStackProps = {
  shadowOffset: {
    width: 0,
    height: 2
  },
  shadowOpacity: 0.08,
  shadowRadius: 4,
  shadowColor: "black",
  pressStyle: pressVariants.default.pressStyle,
  transition: "press"
};
export const StyledRefreshButton = styled(XStack, {
  cursor: "pointer",
  gap: "$2",
  px: "$3",
  py: "$2",
  borderWidth: hairline,
  borderColor: "$borderDefault",
  backgroundColor: "$surface2",
  borderRadius: "$10",
  justifyContent: "center",
  alignItems: "center",
  shadowOffset: {
    width: 0,
    height: 2
  },
  shadowOpacity: 0.08,
  shadowRadius: 4,
  shadowColor: "black",
  hoverStyle: {
    backgroundColor: "$surface2Hover",
    borderColor: "$borderDefaultHover"
  },
  pressStyle: {
    backgroundColor: "$surface2Hover",
    borderColor: "$borderDefaultHover",
    ...pressVariants.default.pressStyle
  },
  transition: "press"
});
export const StyledLinkStatus = styled(XStack, {
  justifyContent: "space-between",
  alignItems: "center",
  gap: "$2",
  px: "$3",
  py: "$2",
  borderRadius: "$10",
  borderWidth: hairline,
  borderColor: "$color4",
  backgroundColor: "$color3"
});
export const FeedbackIconWrapper = styled(View, {
  position: "absolute",
  left: 8,
  top: 8,
  width: 16,
  height: 16,
  zIndex: 1
});
export const FeedbackButton = styled(XStack, {
  render: "button",
  unstyled: true,
  width: "100%",
  height: "100%",
  cursor: "pointer",
  backgroundColor: "transparent",
  position: "relative",
  overflow: "hidden"
});

// Normally we'd use $background, but in Granted’s theme (see
// component-themes.ts) for buttons,
// this maps buttons to dark blue. To avoid unintended global changes, we use $white1.
const StyledSelectButtonInner = styled(Button, {
  unstyled: true,
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
  margin: 0,
  borderWidth: 1,
  borderColor: "$borderDefault",
  backgroundColor: "$surface2",
  borderRadius: "$10",
  height: 50,
  transition: "press",
  paddingHorizontal: "$sp2",
  hoverStyle: {
    borderColor: "$borderDefaultHover",
    backgroundColor: "$surface2Hover"
  },
  pressStyle: {
    margin: 0,
    borderWidth: 2,
    borderColor: "$borderDefaultHover",
    backgroundColor: "$surface2Hover",
    ...pressVariants.default.pressStyle
  },
  variants: {
    tone: {
      default: {},
      negative: {
        borderColor: "$borderNegative",
        hoverStyle: {
          borderColor: "$borderNegativeHover",
          backgroundColor: "$surface2Hover"
        },
        pressStyle: {
          borderColor: "$borderNegativeHover",
          backgroundColor: "$surface2Hover"
        }
      }
    },
    selected: {
      true: {
        margin: 0,
        borderWidth: 2,
        borderColor: "$borderIntense",
        backgroundColor: "$surface2",
        hoverStyle: {
          borderColor: "$borderIntense"
        },
        pressStyle: {
          borderColor: "$borderIntense"
        }
      }
    }
  } as const,
  defaultVariants: {
    tone: "default"
  }
});
export const StyledSelectButton = ({
  children,
  ...props
}: React.ComponentProps<typeof StyledSelectButtonInner>) => <StyledSelectButtonInner {...props} data-sentry-element="StyledSelectButtonInner" data-sentry-component="StyledSelectButton" data-sentry-source-file="GeneralStyledComponents.tsx">
    <Button.Text color={props.tone === "negative" ? "$textNegative" : "$textDefault"} size="$4" data-sentry-element="Button.Text" data-sentry-source-file="GeneralStyledComponents.tsx">
      {children}
    </Button.Text>
  </StyledSelectButtonInner>;
export const StyledPlaceholderLine = styled(XStack, {
  height: 8,
  width: "100%",
  backgroundColor: "$gray5",
  borderRadius: 2
});